<template>
    <RegularModal ref="modal">
        <template v-slot:title>{{ translate("admin_show_bracket.add_missing_competitor_to_bracket") }}</template>
        <template v-slot:body>
            <div class="columns" v-if="initDone">
                <div class="column" v-if="availableByeSpots">
                    <div
                        class="box is-flex is-justify-content-space-between is-align-items-center"
                        v-for="missingCompetitor in missingCompetitors"
                        :key="missingCompetitor.id"
                    >
                        <div>
                            <Country :country-code="missingCompetitor.nationality" :only-flag="true" />
                            <span class="clarity-mask">{{ missingCompetitor.firstName }} {{ missingCompetitor.lastName }}</span>
                        </div>

                        <div>
                            <button class="button is-small is-primary" @click="choose(missingCompetitor)">
                                <span class="icon">
                                    <i class="fas fa-user-plus" />
                                </span>
                                <span>{{ translate("admin_show_bracket.add_competitor") }}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="column" v-else>
                    <Notification class="is-danger">
                        <span class="icon">
                            <i class="fas fa-exclamation-triangle" />
                        </span>
                        <span>
                            {{ translate("admin_show_bracket.no_avail_spots") }}
                        </span>
                    </Notification>
                </div>
            </div>
            <div v-else class="columns is-mobile is-centered">
                <LoadingSpinner2 class="has-added-margin" />
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons" @click="close">
                <button class="button">{{ translate("common.cancel") }}</button>
            </div>
        </template>
    </RegularModal>
</template>

<script>
    import RegularModal from "../Common/RegularModal.vue";
    import apiMixin from "../Api/apiMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import Country from "../Common/Country.vue";
    import Notification from "../Common/Notification.vue";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "add-missing-competitor-modal",
        components: { LoadingSpinner2, Notification, Country, RegularModal },
        mixins: [apiMixin, errorHandlerMixin, translatorMixin],
        props: ["eventId"],
        data() {
            return {
                parameterId: 0,
                missingCompetitors: [],
                availableByeSpots: false,
                initDone: false,
            };
        },
        methods: {
            close() {
                this.$refs.modal.close();
            },
            open(parameterId) {
                this.parameterId = parameterId;
                this.missingCompetitors = [];
                this.availableByeSpots = false;
                this.initDone = false;

                this.$refs.modal.open();

                return this.fetchMissingCompetitors().finally(() => {
                    this.initDone = true;
                });
            },
            choose(eventRegistration) {
                this.$emit("missingCompetitorChosen", eventRegistration);
                this.close();
            },
            fetchMissingCompetitors() {
                return this.bracketsApi()
                    .getMissingCompetitorsFromBracket(this.eventId, this.parameterId)
                    .then(missingCompetitorsResponse => {
                        this.missingCompetitors = missingCompetitorsResponse.missingCompetitors;
                        this.availableByeSpots = missingCompetitorsResponse.availableByeSpots;
                    })
                    .catch(this.handleError);
            },
        },
    };
</script>

<style scoped></style>
